import React, { useEffect, useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import PLTable from '../../PL/PLTable/PLTable';
import Queries from '../../../utils/API/Queries';
import UILabeledInput from '../../UI/UILabeledInput';
import UIOverlayCard from '../../UI/UIOverlayCard';
import { OPTIONS_TABLE_TYPE } from '../../PL/PLTable/config';
import { UI_LABELED_INPUT_TEXT_TYPE } from '../../UI/UILabeledInput/config';
import { getSelectedRegionSelector } from '../../../redux/selectors/CurrentUserSelectors';
import { useApolloClient } from 'react-apollo';
import { toast } from 'react-toastify';

export default function SelectOptionModal({ selectOption, hideModal, filterType }: SelectOptionModalProps) {
	const selectedRegion = useSelector(getSelectedRegionSelector);

	const [searchParams, setSearchParams] = useState<string>('');
	const [regionOptions, setRegionOptions] = useState<OptionType[]>([]);

	const client = useApolloClient();

	const getOptions = async () => {
		let variables;

		if (filterType) {
			variables = {
				query: {
					name: { op_iLike: '%' + searchParams + '%' },
					type: { op_eq: filterType }
				},
				region: selectedRegion.id
			};
		} else {
			variables = {
				query: {
					name: { op_iLike: '%' + searchParams + '%' }
				},
				region: selectedRegion.id
			};
		}
		const response = await client
			.query({
				query: Queries.GET_OPTIONS,
				variables
			})
			.catch(toast.error);
		const { options: regionOptions } = response['data'];
		if (regionOptions) {
			setRegionOptions(regionOptions);
		}
	};

	useEffect(() => {
		(async () => {
			await getOptions();
		})();
	}, []);

	if (!regionOptions) return null;

	const onSearchParamsUpdated = async (searchParams) => {
		setSearchParams(searchParams);
		await getOptions();
	};

	return (
		<UIOverlayCard hideModal={hideModal} className='fade-in-div selectOptionModal'>
			<div className='fixedSearchBar'>
				<UILabeledInput
					type={UI_LABELED_INPUT_TEXT_TYPE}
					onChangeValue={onSearchParamsUpdated}
					value={searchParams}
					containerStyle={{ width: 480 }}
					style={{ width: '100%' }}
					placeholder={'search by option name...'}
				/>
			</div>

			{regionOptions && (
				<div className='selectOptionModal__table'>
					<PLTable
						emptySetText={regionOptions ? '' : 'There are no options matching your query.'}
						type={OPTIONS_TABLE_TYPE}
						data={regionOptions}
						onSelect={(option) => {
							selectOption(option);
							setSearchParams('');
						}}
						limit={200}
						updateTable={getOptions}
					/>
				</div>
			)}
		</UIOverlayCard>
	);
}
